import { create } from "zustand";
import getLostCustomers from "../api/lost-customer";
import getActiveCustomers from "../api/active-customer";
import getEngageCustomers from "../api/engage-customer";

const useLostCustomers = create((set) => ({
  lostCustomerData: [],
  activeCustomerData: [],
  engageCustomerData: [],
  isLoading: false,
  isError: false,
  fetchLostCustomerData: async (agentId) => {
    try {
      // set({ isLoading: true });
      // const responses = await getLostCustomers(agentId);
      // set({ lostCustomerData: responses });
    } catch (error) {
      set({ isError: true, data: [] });
    } finally {
      set({ isLoading: false });
    }
  },
  fetchActiveCustomerData: async (agentId) => {
    try {
      // set({ isLoading: true });
      // const responses = await getActiveCustomers(agentId);
      // set({ activeCustomerData: responses });
    } catch (error) {
      set({ isError: true, data: [] });
    } finally {
      set({ isLoading: false });
    }
  },
  fetchEngageCustomerData: async (agentId) => {
    try {
      // set({ isLoading: true });
      // const responses = await getEngageCustomers(agentId);
      // set({ engageCustomerData: responses });
    } catch (error) {
      set({ isError: true, data: [] });
    } finally {
      set({ isLoading: false });
    }
  },
}));

export default useLostCustomers;
